"use client";

import { useEffect, useState } from "react";
import posthog from "posthog-js";
import { SearchBoxV2 } from "@/components/SearchBoxV2";
import OnboardingForm from "@/components/OnboardingForm";

export const OnboardingExperiment = () => {
  const [showOnboarding, setShowOnboarding] = useState<boolean | null>(true);

  useEffect(() => {
    const checkFeatureFlag = () => {
      // We want to make sure PostHog is loaded and feature flags are ready
      posthog.onFeatureFlags(() => {
        const experimentResult = posthog.getFeatureFlag('onboarding-form-experiment');
        // setShowOnboarding(experimentResult === 'test');
        setShowOnboarding(true);
      });
    };

    checkFeatureFlag();
  }, []);

  // Show search box until feature flag is loaded (default experience)
  if (showOnboarding === null) {
    return (
      <SearchBoxV2
        placeHolderText={["Search for projects or locations..."]}
        useLinksForResults={true}
      />
    );
  }

  // Render based on experiment variant
  return showOnboarding ? (
    <OnboardingForm />
  ) : (
    <SearchBoxV2
      placeHolderText={["Search for projects or locations..."]}
      useLinksForResults={true}
    />
  );
};

export default OnboardingExperiment; 